let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("inRhy")).then(() => parcelRequire('7XODf'));